module.exports = __webpack_public_path__ + "static/media/ladder.aab52c4f.jpg";